import { gql } from "@apollo/client";

export const GET_COMPANY_QUERY = gql`
  query GET_COMPANY_QUERY($_id: ID!) {
    getCompany(_id: $_id) {
      _id
      fantasyName
      description
      bgImg
      domain
      productCategories {
        _id
        name
        image
      }
    }
  }
`;
